import { render, staticRenderFns } from "./CustomResults.vue?vue&type=template&id=4c18148e&scoped=true"
import script from "./CustomResults.vue?vue&type=script&lang=js"
export * from "./CustomResults.vue?vue&type=script&lang=js"
import style0 from "./CustomResults.vue?vue&type=style&index=0&id=4c18148e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c18148e",
  null
  
)

export default component.exports